// extracted by mini-css-extract-plugin
export var background = "Background-module--background--3Vkwl";